export enum IOrderFields {
    Name = 'Name',
    Location = 'Location',
    Image = 'Image',
}

export interface IDeleteUserForm {
    accommodationId?: number;
}
